import React, { Component } from "react";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../navigationSection/BottomNavigationMobile";
import { TopNavigationBarMobile } from "../navigationSection/TopNavigationBarMobile";
import NewOpenIssuesVendorDashboard from "./InsidePages/NewOpenIssuesVendorDashboard";
import InProcessOpenIssuesVendorDashboard from "./InsidePages/InProcessOpenIssuesVendorDashboard";
import ClosedOpenIssuesVendorDashboard from "./InsidePages/ClosedOpenIssuesVendorDashboard";
import AllOpenIssuesVendorDashboard from "./InsidePages/AllOpenIssuesVendorDashboard";
import { Button, Container, Row, Col, Form } from "react-bootstrap";
import Filter from "../openIssuesVendor/Filter";
// import AddOpenIssuesVendor from "../../superAdminComponents/superAdminAllComponent/superAdminOpenIssuesVendor/InsideAllPageComponent/AddOpenIssuesVendor";
import AddVendorSuggestionIssuesPopup from "./AddIssuesPopup/AddVendorSuggestionIssuesPopup";
import Media from "react-media";

import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";

class DisputeManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 1,
    };
  }

  pageChangeButtonHandler = (value) => {
    this.setState({
      selectedTab: value,
    });
  };

  render() {
    return (
      <React.Fragment>
        <Container fluid>
          <Row>
            <Media query="(min-width: 992px)">
              <div className="left-side-panel">
                <LeftSideNavigation />
              </div>
            </Media>

            {/* <div className="top-panel">
              <TopNavigationBarMobile displayLeft="logo" />
            </div> */}
            <div className="right-side-panel main-seating-dashboard-body vendoropensuggestionissues-main-mobile">
              <RightSideNavigation
                // leftText="vendorReview"
                // backButtonLink="/seatingdashboard"
                // displayText="Vendor Open Issues and Suggestions"
                displayButton="addOpenIssuesVendorSuggestion"
                newButton={true}
              />
              <Media query="(min-width: 992px)">
                <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                  <div className="f24_700_HelveticaNeue">
                    Dispute Management
                  </div>
                  {/* <AddOpenIssuesVendor /> */}
                  <AddVendorSuggestionIssuesPopup />
                </div>
              </Media>
              <div className="d-flex flex-wrap align-items-center">
                <Button
                  variant="link"
                  className={`px-0 mr-4 text-grayLink f12-500 ${
                    this.state.selectedTab === 1 ? "active" : ""
                  }`}
                  onClick={() => this.pageChangeButtonHandler(1)}
                >
                  New
                </Button>
                <Button
                  variant="link"
                  className={`px-0 mr-4 text-grayLink f12-500 ${
                    this.state.selectedTab === 2 ? "active" : ""
                  }`}
                  onClick={() => this.pageChangeButtonHandler(2)}
                >
                  In-Process
                </Button>
                <Button
                  variant="link"
                  className={`px-0 mr-4 text-grayLink f12-500 ${
                    this.state.selectedTab === 3 ? "active" : ""
                  }`}
                  onClick={() => this.pageChangeButtonHandler(3)}
                >
                  Closed
                </Button>
                <Button
                  variant="link"
                  className={`px-0 mr-4 text-grayLink f12-500 ${
                    this.state.selectedTab === 4 ? "active" : ""
                  }`}
                  onClick={() => this.pageChangeButtonHandler(4)}
                >
                  All
                </Button>
              </div>

              <Media query="(max-width: 991px)">
                <hr />
              </Media>
              <Row className="align-items-center">
                {/* <Col className="col-auto seating-topbar-search">
                  <div className="filter-button">
                    <Filter />
                  </div>
                </Col> */}
                {/* <Col xs={8} md={4}>
                  <div className="filter-button-search">
                    <Paper component="form" className="enSearch2 d-flex">
                      <IconButton type="submit" aria-label="search">
                        <SearchIcon />
                      </IconButton>
                      <InputBase
                        placeholder="Search"
                        name="search"
                        inputProps={{
                          "aria-label": "Search by Name or Phone Number",
                        }}
                        // onChange={onSearchChange}
                        // value={state.search}
                      />
                    </Paper>
                  </div>
                </Col> */}
              </Row>
              {/* <Row className="align-items-center pt-4">
                <Col className="col-auto seating-topbar-search">
                  <div className="filter-button">
                    <Filter />
                  </div>
                </Col>
                <Col md={4}>
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    className="amSearch"
                  />
                </Col>
              </Row> */}
              <div className="row">
                <div className="col-12">
                  {this.state.selectedTab === 1 ? (
                    <NewOpenIssuesVendorDashboard
                      pageChanger={this.pageChangeButtonHandler}
                      selectedTab={this.state.selectedTab}
                    />
                  ) : null || this.state.selectedTab === 2 ? (
                    <InProcessOpenIssuesVendorDashboard
                      pageChanger={this.pageChangeButtonHandler}
                      selectedTab={this.state.selectedTab}
                    />
                  ) : null || this.state.selectedTab === 3 ? (
                    <ClosedOpenIssuesVendorDashboard
                      pageChanger={this.pageChangeButtonHandler}
                      selectedTab={this.state.selectedTab}
                    />
                  ) : null || this.state.selectedTab === 4 ? (
                    <AllOpenIssuesVendorDashboard
                      pageChanger={this.pageChangeButtonHandler}
                      selectedTab={this.state.selectedTab}
                    />
                  ) : null}
                </div>
              </div>
            </div>
            {/* <div className="right-side-panel"></div> */}
            <Media query="(max-width: 991px)">
              <div className="bottom-panel">
                <BottomNavigationMobile />
              </div>
            </Media>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default DisputeManagement;
